export class OrderTotals {

  public cryptoAmountCanVary: boolean;
  public baseCurrencyPrecision: number;
  public baseAmountAfterFees: number;
  public quoteAmountAfterFees: string;
  public commissionAmount: number;
  public totalCommissionAmount: number;
  public totalDiscountAmount: number;
  public discountConcept: string;
  public networkFee: number;
  public commissionAmountPercentage: number;
  public currencyAmount: string;
  public cryptoAmount: number;

}
